import GenericModel from './generic-model'

export default class UserProducts extends GenericModel {
  constructor(userId) {
    super(`users/${userId}/products`)
  }

  // Here you can extend UserProductsDB with custom methods
}
